var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "7px",
    viewBox: "0 0 4 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4DCF963A-E5FE-4DBC-9D89-EA69E5477260@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.000125,5.65921307 C1.87794318,5.65921307 1.75576136,5.61021307 1.66269318,5.51271307 L-1.20094318,2.51271307 C-1.38755682,2.31721307 -1.38755682,2.00121307 -1.20094318,1.80571307 C-1.01432955,1.61021307 -0.712693182,1.61021307 -0.526079545,1.80571307 L2.000125,4.45221307 L4.52632955,1.80571307 C4.71294318,1.61021307 5.01457955,1.61021307 5.20119318,1.80571307 C5.38780682,2.00121307 5.38780682,2.31721307 5.20119318,2.51271307 L2.33755682,5.51271307 C2.24448864,5.61021307 2.12230682,5.65921307 2.000125,5.65921307",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7.-Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1175.000000, -528.000000)",
    id: "Refer-and-Earn"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(135.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-Chevron-Down",
    fill: "#CC215D",
    transform: "translate(2.000125, 3.659151) scale(-1, -1) rotate(90.000000) translate(-2.000125, -3.659151) ",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSmall);
export default __webpack_public_path__ + "static/media/ChevronSmall.38739ed8b5b733af310c71a279224524.svg";
export { ForwardRef as ReactComponent };